import "./banner.css";

const Banner = () => {
  return (
    <section className="banner-container" id="home">
      <div className="banner">
        <h1 className="banner-title unobserve">welcome</h1>
        <p className="banner-subtitle unobserve">
          To a Full Beauty Saloon Experience
        </p>
      </div>
    </section>
  );
};

export default Banner;
